// extracted by mini-css-extract-plugin
export default {"Textarea":"Textarea_Textarea__HvXmq","disabled":"Textarea_disabled__lwx8v","Textarea__Input":"Textarea_Textarea__Input__ooHKR"};